<template>

    <div>
        <div v-if="loadAllcontent">
            <a-card>
                <template slot="title">
                    <h5 class="mt-10 mb-10 ml-10"><a-avatar style="background-color: #6a0dad;" shape="square" :size="90"
                            icon="user" :src="`/images/MUICCOPTERGIF.gif`" class="mr-30 avatar" /> Verifying your <b
                            style="color: #462279;">Copter–MUIC’s AI-powered personal</b> usage authorization</h5>
                </template>
                <div class="pa-10">

                    <h4 class="mt-10 mb-10 ml-30">You do <span class="text-danger">Not have permission</span> to use
                        this service.</h4>
                    <h4 class="mt-20 mb-10 ml-30">Need Help ?</h4>
                    <p style="font-size: 18px;" class="mt-10 mb-10 ml-30 font-web">Please contact our support team at <a
                            :href="'mailto:ic-inhouse@mahidol.edu'">ic-inhouse@mahidol.edu</a></p>
                    <p style="font-size: 18px;" class="mt-10 mb-20 ml-30 font-web">Office Contact :: IN-HOUSE Office
                        1511 (from 08:00
                        a.m. to 05:00 p.m.)</p>

                    <h4 class="mt-10 mb-10 ml-30">Disclaimer & Usage Policy</h4>
                    <div class="ml-20 mr-20 mt-10 mb-20">
                        <a-descriptions class="mt-15 mb-5" layout="vertical" bordered>
                            <a-descriptions-item style="color: #000000 !important;"
                                label="1. Data Privacy & Confidentiality" :span="3">
                                <ul style="font-size: 16px;">
                                    <li>Your interactions with Copter will be monitored for <strong>quality control and
                                            system
                                            improvement</strong> only.</li>
                                    <li><strong>No personal data</strong> shared during your use of Copter will be
                                        disclosed to third
                                        parties.</li>
                                    <li>Conversations and queries are stored anonymously for system enhancement and
                                        performance
                                        evaluation.</li>
                                </ul>
                            </a-descriptions-item>
                            <a-descriptions-item style="color: #000000 !important;"
                                label="2. Information Accuracy & User Responsibility" :span="3">
                                <ul style="font-size: 16px;">
                                    <li>Copter is designed to provide <strong>general guidance</strong> on academic
                                        planning, student
                                        activities, and exchange programs.</li>
                                    <li>
                                        <strong>Do not rely solely on Copter for critical decisions.</strong> It is
                                        <strong>your
                                            responsibility</strong> to verify the information provided by checking with
                                        official
                                        university sources.
                                    </li>
                                    <li>MUIC <strong>does not guarantee</strong> the accuracy, completeness, or
                                        timeliness of responses
                                        generated by the AI system.</li>
                                </ul>
                            </a-descriptions-item>
                            <a-descriptions-item style="color: #000000 !important;" label="3. Limitation of Liability"
                                :span="3">
                                <ul style="font-size: 16px;">
                                    <li>MUIC and the developers of Copter <strong>will not be responsible</strong> for
                                        any consequences
                                        resulting from the use of information provided by Copter.</li>
                                    <li>Any decisions made based on Copter’s responses <strong>are at your own
                                            risk.</strong></li>
                                    <li>Copter <strong>does not replace</strong> official university services, academic
                                        advisors, or
                                        administrative offices.</li>
                                </ul>
                            </a-descriptions-item>
                            <a-descriptions-item label="4. Appropriate Use" :span="3">
                                <ul style="font-size: 16px;">
                                    <li>Users must engage with Copter <strong>ethically and respectfully.</strong></li>
                                    <li>Any attempt to misuse the system, input harmful content, or manipulate responses
                                        may result in
                                        <strong>restricted access.</strong>
                                    </li>
                                </ul>
                            </a-descriptions-item>
                        </a-descriptions>
                    </div>



                </div>
            </a-card>
        </div>
        <div v-else>
            <div class="chat-container" style="border-radius: 10% !important;">

                <!-- Sidebar 462279 -->
                <div :class="['sidebar', { 'sidebar-hidden': !isDesktop && activeChat }]">

                    <!-- รายการแชท -->
                    <div class="sidebar-header">
                        <div>
                            <h6 class="mt-10 mb-10 ml-10 font-web"><a-icon class="mr-10" type="unordered-list" />
                                History </h6>
                        </div>
                        <div class="text-right">
                            <a-tooltip placement="top">
                                <template slot="title">
                                    <span>New Chat</span>
                                </template>
                                <a-button @click="handleOpenModalId" type="link" size="large">
                                    <strong><a-icon type="form"
                                            style="font-size: 28px; color: #462279 !important; font-weight: 900;" /></strong>
                                </a-button>
                            </a-tooltip>
                        </div>
                    </div>
                    <!-- รายการแชท -->
                    <ul class="chat-list">
                        <li v-for="(chat, index) in chats" :key="index" @click="selectChat(chat)"
                            :class="{ 'active-chat': activeChat === chat }">
                            <div class="chat-info">
                                <p class="chat-name">{{ chat.name }}</p>
                                <p v-if="chat.name !== 'Loading ...'" style="font-size: 12px !important"
                                    class="chat-message">
                                    <a-icon type="calendar" class="mr-5" /> {{ moment(chat.created_at).format('DD / MMM / YYYY') }}
                                    <a-icon class="ml-5 mr-5" type="clock-circle" /> {{
                                        moment(chat.created_at).format('HH:mm:ss') }}
                                </p>
                                <p v-else style="font-size: 12px !important" class="chat-message"><a-icon type="loading"
                                        class="mr-10" />
                                    Copter AI v.1.0 </p>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- Main Chat (activeChat) -->
                <div class="chat-box" v-if="activeChat">

                    <div class="chat-header">
                        <a-button class="mr-10" v-if="!isDesktop" @click="backToChats" type="link" :size="size">
                            <a-icon :style="{ fontSize: '28px', color: '#ffffff !important' }" type="menu-fold" />
                        </a-button>
                        <a-avatar shape="square" size="large" icon="user" src="/images/MUICCOPTERGIF.gif"
                            class="avatar" />
                        <div>
                            <h6 style="color: #ffffff" class="font-web mt-0 mb-0 ml-15"> Copter AI v.1.0 </h6>
                            <p style="font-size: 10px;" class="font-web mt-0 mb-0">
                                <a-button @click="handleOpenmodalProricy" type="link" size="small">
                                    Disclaimer & Usage Policy
                                </a-button>
                            </p>
                        </div>
                    </div>


                    <div ref="chatMessages" :class="['chat-messages', { 'shrink-messages': isInputFocused }]">
                        <div v-for="(message, index) in activeChat.messages" :key="index"
                            :class="['message', message.from === 'me' ? 'sent' : 'received']">

                            <div :class="[{ 'flex-recive': isDesktop }]">
                                <div v-if="message.from === 'them' && isDesktop">
                                    <a-avatar style="background-color: #6a0dad;" shape="square" size="large" icon="user"
                                        :src="message.id === `${resText}` ? `/images/MUICCOPTERGIF.gif` : `/images/Khuncopter.png`"
                                        class="avatar" />
                                </div>
                                <div :ref="`chatList-${message.id}`" class=""
                                    :class="[message.from === 'me' ? 'bg-send' : 'bg-recive']">

                                    <p v-if="message.id === `${resText}`" class="mt-0 mb-10 message-text">
                                        <strong>🤔 Copter is thinking <span
                                                class="dots"><span>.</span><span>.</span><span>.</span></span></strong>
                                    </p>

                                    <p v-else style="padding: 10px;" class="mt-0 mb-0 message-text">

                                        <typing-markdown v-if="loadingStream === message.id"
                                            :markdown-content="message.text" :typing-speed="10"></typing-markdown>
                                        <span v-else class="markdown-content"
                                            v-html="renderMarkdown(message.text)"></span>
                                    </p>

                                    <div v-if="message.from === 'them' && visiblePopcon === message.id" style=""
                                        class="ml-20 mr-20 mt-0 mb-20">
                                        <div class="text-center">
                                            <a-rate class="mb-10" style="font-size: 32px;" size="large"
                                                v-model="valueRate" />
                                        </div>
                                        <a-textarea v-model="valueComment" placeholder="comment / suggest  (if any)"
                                            :auto-size="{ minRows: 3, maxRows: 5 }" />
                                        <div class="mt-10 text-right">
                                            <a-button :loading="loadingFeed"
                                                @click="feedbackMsg(message.id, activeChat.id)"
                                                :disabled="['', 0, null, 'null'].includes(valueRate)"
                                                :style="{ fontSize: '14px', fontWeight: '300', color: '#ffffff', backgroundColor: ['', 0, null, 'null'].includes(valueRate) || ['', 0, null, 'null'].includes(valueComment) ? '#9AA6B2' : '#3D8D7A' }"
                                                class="mr-5">Comment</a-button>
                                            <a-button @click="closeFeedBack"
                                                :style="{ fontSize: '14px', fontWeight: '300', color: '#ffffff', backgroundColor: '#D91656' }">Close</a-button>
                                        </div>
                                    </div>

                                    <span class="message-time" style="margin-top: -15px;">
                                        <span class="mt-5"><a-icon
                                                style="color: #758694;font-size:14px;font-weight: 900; overlay: 10px"
                                                class="ml-5 mr-5" type="clock-circle" theme="filled" /> {{ message.time
                                                }}
                                        </span>
                                        <span v-if="['them'].includes(`${message.from}`)" class="text-center">
                                            <a-tooltip placement="top">
                                                <template slot="title">
                                                    <span>Copy</span>
                                                </template>
                                                <a-button style="font-size:14px;font-weight: 700; overlay: 10px"
                                                    size="small" type="link" class="ml-0">
                                                    <span class="text-small text-muted"><a-icon
                                                            style="color: #758694;font-size:14px;font-weight: 900; overlay: 10px"
                                                            type="copy" theme="filled" /></span>
                                                </a-button>
                                            </a-tooltip>
                                        </span>
                                        <span v-if="['them'].includes(`${message.from}`)" class="text-center">
                                            <a-tooltip placement="top">
                                                <template slot="title">
                                                    <span>Bad response</span>
                                                </template>

                                                <a-button v-if="message.feedback" type="link"
                                                    @click="feedbackMsgBad(message.id, activeChat.id)"
                                                    class="chat-vote-icon ml-0">
                                                    <span class="text-small text-primary"><a-icon
                                                            style="color: #758694;font-size:14px;font-weight: 900; overlay: 10px"
                                                            type="dislike" theme="filled" /></span>
                                                </a-button>
                                            </a-tooltip>
                                        </span>
                                        <span
                                            v-if="['them'].includes(`${message.from}`) && [false, '', 'false'].includes(visiblePopcon)"
                                            class="text-center">
                                            <a-tooltip placement="top">
                                                <template slot="title">
                                                    <span>Feedback</span>
                                                </template>
                                                <a-button v-if="message.feedback"
                                                    @click="clearValueFeedBack(message.id)" type="link"
                                                    class="chat-vote-icon ml-0">
                                                    <span class="text-small text-primary"><a-icon
                                                            style="color: #758694;font-size:14px;font-weight: 900; overlay: 10px"
                                                            type="like" theme="filled" /></span>
                                                </a-button>
                                            </a-tooltip>
                                        </span>
                                        <span v-if="['them'].includes(`${message.from}`)" class="text-center">

                                            <a-tooltip placement="top">
                                                <template slot="title">
                                                    <span>Refresh answer</span>
                                                </template>
                                                <a-button style="font-size:14px;font-weight: 700; overlay: 10px"
                                                    size="small" type="link" class="ml-0"
                                                    @click="handleSendMessage(activeChat.messages[index - 1].id)">
                                                    <span class="text-small text-muted"><a-icon
                                                            style="color: #758694;font-size:14px;font-weight: 900; overlay: 10px"
                                                            type="sync" /></span>
                                                </a-button>
                                            </a-tooltip>
                                        </span>

                                    </span>

                                </div>
                                <div v-if="message.from === 'me' && isDesktop">

                                    <a-avatar shape="square" size="large" class="avatar"
                                        :src="gender === 'female' ? `/images/girlStd.png` : `/images/manStd.png`" />
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="chat-input">
                        <textarea :disabled="activeChat.id === 9999" v-model="newMessage"
                            placeholder="Type message... (Press Shift + Enter for new line)"
                            @input="adjustTextareaHeight" @keydown="handleKeyDown" ref="messageInput"></textarea>
                        <button :disabled="activeChat.id === 9999" class="send-button ml-10"
                            @click="handleSendMessage(false)">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M22 2L11 13" />
                                <path d="M22 2L15 22L11 13L2 9L22 2Z" />
                            </svg>
                        </button>
                    </div>
                    <p style="font-size: 14px !important;" class="mt-0 mb-5 text-dark font-web ai-warning">Copter AI can
                        make
                        mistakes. Check important info.</p>
                    <div class="mb-10 mt-5 text-center">
                        use Copter AI Download <strong>IC-APP</strong> Mobile Application <a class="ml-10 mr-10"
                            href="https://apps.apple.com/app/ic-app/id6469416277" target="_blank"
                            rel="noopener noreferrer">
                            <a-icon type="apple" class="mr-5" />App Store
                        </a>
                        |
                        <a class="ml-10" href="https://play.google.com/store/apps/details?id=muic.inhouse.icapp"
                            target="_blank" rel="noopener noreferrer">
                            <a-icon type="android" class="mr-5" />Google Play
                        </a>
                    </div>
                </div>

                <!-- modal -->
                <a-modal :width='700' title="Copter AI Disclaimer & Usage Policy" :visible="modalProricy"
                    @cancel="handleClosemodalProricy">
                    <div class="mt-10 mb-10">
                        <div class="text-center">
                            <p class="mt-0 mb-0 font-web" style="font-size: 16px;">
                                <strong>Welcome to Copter – Your AI-Powered Personal Assistant! 🤖 🎓</strong>
                            </p>
                            <p class="mt-5 mb-0 font-web">
                                Before you begin, please review the following disclaimer and usage policy carefully.
                            </p>
                        </div>
                        <a-descriptions class="mt-15 mb-5" layout="vertical" bordered>
                            <a-descriptions-item label="1. Data Privacy & Confidentiality" :span="3">
                                <ul>
                                    <li>Your interactions with Copter will be monitored for <strong>quality control and
                                            system
                                            improvement</strong> only.</li>
                                    <li><strong>No personal data</strong> shared during your use of Copter will be
                                        disclosed to
                                        third parties.</li>
                                    <li>Conversations and queries are stored anonymously for system enhancement and
                                        performance
                                        evaluation.</li>
                                </ul>
                            </a-descriptions-item>
                            <a-descriptions-item label="2. Information Accuracy & User Responsibility" :span="3">
                                <ul>
                                    <li>Copter is designed to provide <strong>general guidance</strong> on academic
                                        planning,
                                        student activities, and exchange programs.</li>
                                    <li>
                                        <strong>Do not rely solely on Copter for critical decisions.</strong> It is
                                        <strong>your
                                            responsibility</strong> to verify the information provided by checking with
                                        official
                                        university sources.
                                    </li>
                                    <li>MUIC <strong>does not guarantee</strong> the accuracy, completeness, or
                                        timeliness of
                                        responses generated by the AI system.</li>
                                </ul>
                            </a-descriptions-item>
                            <a-descriptions-item label="3. Limitation of Liability" :span="3">
                                <ul>
                                    <li>MUIC and the developers of Copter <strong>will not be responsible</strong> for
                                        any
                                        consequences resulting from the use of information provided by Copter.</li>
                                    <li>Any decisions made based on Copter’s responses <strong>are at your own
                                            risk.</strong>
                                    </li>
                                    <li>Copter <strong>does not replace</strong> official university services, academic
                                        advisors, or administrative offices.</li>
                                </ul>
                            </a-descriptions-item>
                            <a-descriptions-item label="4. Appropriate Use" :span="3">
                                <ul>
                                    <li>Users must engage with Copter <strong>ethically and respectfully.</strong></li>
                                    <li>Any attempt to misuse the system, input harmful content, or manipulate responses
                                        may
                                        result in <strong>restricted access.</strong></li>
                                </ul>
                            </a-descriptions-item>
                        </a-descriptions>
                    </div>
                    <template slot="footer">
                        <div class="">
                            <a-button style="width: 100px !important;" class="ml-10"
                                @click="handleClosemodalProricy">Close</a-button>
                        </div>
                    </template>
                </a-modal>

                <!-- modal -->
                <a-modal title="Suppose you are a student" :visible="modalUserId" @cancel="handleCloseModalId">
                    <div class="mt-10 mb-10">
                        <a-form-item
                            help="Please enter your designated student ID for simulation purposes before using the AI system.">
                            <a-input-search :max-length="7" v-model="userName" class="mb-2"
                                placeholder="search student id simulation" enter-button="Check" size="large"
                                @search="onSearch" />
                        </a-form-item>
                        <p v-if="![''].includes(errorStatus)" class="font-web mt-0 mb-0 text-danger">Error message : {{
                            errorStatus }}
                        </p>
                    </div>
                    <template slot="footer">
                        <div class="">
                            <a-button type="primary" icon="wechat" style="width: 150px !important;" class="ml-10"
                                :disabled="!idStatus" @click="createToppic" :loading="loadingCreateMsg">Create New
                                Chat</a-button>
                            <a-button style="width: 100px !important;" class="ml-10"
                                @click="handleCloseModalId">Close</a-button>
                        </div>
                    </template>
                </a-modal>

                <!-- modal eror -->
                <a-modal title="Copter is currently unavailable." :footer="null" :visible="visibleModal">
                    <a-result status="500" title="500" sub-title="Sorry, Copter is wrong.">
                        <div class="desc">
                            <p class="mt-0 mb-0 font-web" style="font-size: 16px;">
                                <strong>The content you following error:</strong>
                            </p>
                            <p class="mt-10 mb-0 font-web">
                                <a-icon :style="{ color: 'red' }" type="close-circle" /> Status:
                                <br> Identified
                                We have identified the issue and are working to roll out a fix.
                            </p>
                        </div>
                    </a-result>
                    <template slot="footer">
                    </template>
                </a-modal>

            </div>
        </div>
    </div>

</template>

<script>
import { marked } from "marked";
import TypingMarkdown from './TypingMarkdown.vue'

export default {
    components: {
        TypingMarkdown
    },
    data() {
        return {
            //
            loadAllcontent: false,
            // old
            loadingFeed: false,
            closeInput: true,
            visibleModal: false,
            loadingContent: false,
            dataToppic: [],
            loadingToppic: false,
            dataChat: [],
            dataViewMsg: [],
            loadingChat: false,
            checkedList: ['ข้อมูลทั่วไป', 'ข้อมูลการศึกษา', 'คู่มือการใช้งาน', 'ช่วยแจ้งปัญหา / สร้างแบบคำขอ'],
            plainOptions: ['ข้อมูลทั่วไป', 'ข้อมูลการศึกษา', 'คู่มือการใช้งาน', 'ช่วยแจ้งปัญหา / สร้างแบบคำขอ'],
            defaultCheckedList: ['ข้อมูลทั่วไป', 'ข้อมูลการศึกษา', 'คู่มือการใช้งาน', 'ช่วยแจ้งปัญหา / สร้างแบบคำขอ'],
            indeterminate: true,
            checkAll: false,
            pagination: {
                onChange: page => {
                    console.log(page);
                },
                pageSize: 6,
            },
            textContent: '',
            valueRate: 0,
            valueComment: '',
            visiblePopcon: false,
            loadingCreateMsg: false,
            lockInput: false,
            //
            modalUserId: false,
            userName: '',
            modeChat: true,
            firstChat: '',
            // check id status
            idStatus: false,
            errorStatus: '',
            //
            viewHistoryChat: false,
            // new
            isInputFocused: false, // เช็คว่ามีการคลิกที่ input หรือไม่
            isDesktop: globalThis.innerWidth >= 768,
            newMessage: "",
            activeChat: null,
            userProfile: {
                name: "",
                avatar: "",
                online: false,
            },

            chats: [],
            oldMessage: '',
            oldAccount: '',
            // Quota
            dataQuota: {
                id: '',
                user_id: "",
                tier_name: "",
                tokens_per_hour: '',
                requests_per_hour: '',
                created_at: "",
                updated_at: ""
            },
            resText: '',
            modalProricy: false,
            gender: '',
            loadingStream: '',
        };
    },
    updated() {
        if (!this.visiblePopcon) {
            this.scrollToBottom(); // เลื่อนลงล่างทุกครั้งที่มีข้อความใหม่
        }
    },
    created() {
        this.selectChat(this.chats[1].id); // เลือกแชทแรกเมื่อเปิดหน้า
    },
    beforeDestroy() {
        globalThis.removeEventListener("resize", this.checkScreenSize);
    },
    mounted() {
        globalThis.addEventListener("resize", this.checkScreenSize);
        this.checkScreenSize();
        this.scrollToBottom(); // ให้ scrollbar อยู่ด้านล่างสุดเมื่อโหลด
        if (this.$store.state.role.RulesUser.roles.includes("student")) {
            this.getStudentProfile();
        } else {
            this.loadProfile = true;
            this.getBaseProfile();
        }
        this.getQuotaChat()
        this.getHistory();
    },
    methods: {
        async getQuotaChat() {
            try {
                const res = await this.$http.get(`line-bot/ai/quato/`);
                if (res.status === 200) {
                    this.dataQuota = { ...res.data.results[0] };
                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                console.log(error)
            }
        },
        selectChat(chat) {
            this.viewHistoryChat = this.$store.state.role.RulesUser.roles.includes('staff') || this.$store.state.role.RulesUser.roles.includes('faculty') ? false : true
            this.activeChat = chat;
        },
        renderMarkdown(text) {
            if (text.includes("```json") && text.includes('"student_info":')) {
                return 'Please refresh answer !!';
            } else {
                return text && text !== '###loading###' ? text !== "\n" ? marked.parse(text.replace('```', '')) : 'Please refresh answer !!' : "";
            }
        },
        backToChats() {
            this.activeChat = null;
        },
        checkScreenSize() {
            this.isDesktop = globalThis.innerWidth >= 1190;
        },
        // profile Staff
        async getBaseProfile() {
            this.userProfile = {
                name: "",
                avatar: "",
                online: true,
            }
            try {
                const resBaseProfile = await this.$http.get(`/staff/profile/me/`);
                if (resBaseProfile.status === 200) {
                    this.gender = resBaseProfile.data.title.name_eng === 'Mr.' ? 'male' : 'female'
                    this.userProfile = {
                        name: `${resBaseProfile.data.title.name_eng} ${resBaseProfile.data.name} ${resBaseProfile.data.surname}`,
                        avatar: resBaseProfile.data.img,
                        online: true,
                    }
                } else {
                    const error = new Error('API Error');
                    error.resBaseProfile = resBaseProfile;
                    throw error;
                }
            } catch (error) {
                this.$notification.open({
                    style: {
                        backgroundColor: "#ff1919",
                        color: "#ffffff",
                    },
                    message: function (h) {
                        return h("div", [h("strong", { class: "" }, `Error`)]);
                    },
                    description: `Promblem issue connect api : /staff/profile/me/`,
                });
            }
        },
        // profile Std
        async getStudentProfile() {
            this.userProfile = {
                name: "",
                avatar: "",
                online: true,
            }
            try {
                const resStudent = await this.$http.get(`/student/profile/me/`);
                if (resStudent.status === 200) {
                    this.gender = resStudent.data.gender
                    this.userProfile = {
                        name: `${resStudent.data.title} ${resStudent.data.english_first_name} ${resStudent.data.english_last_name}`,
                        avatar: "https://icapp.muic.mahidol.ac.th/source/pic/" +
                            resStudent.data.id +
                            ".jpg",
                        online: true,
                    }
                } else {
                    const error = new Error('API Error');
                    error.resStudent = resStudent;
                    throw error;
                }
            } catch (error) {
                this.$notification.open({
                    style: {
                        backgroundColor: "#ff1919",
                        color: "#ffffff",
                    },
                    message: function (h) {
                        return h("div", [h("strong", { class: "" }, `Error`)]);
                    },
                    description: `Promblem issue connect api : /student/profile/me`,
                });
            }
        },
        //
        scrollToBottom() {
            this.$nextTick(() => {
                const chatMessages = this.$refs.chatMessages;
                if (chatMessages) {
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
            });
        },
        // chat condition
        getDefaultIntroMessage() {
            return [{
                id: '8888',
                from: "them",
                text: `<span class='text-dark' >Hi <strong>${this.userProfile.name}</strong>! &nbsp;&nbsp;&nbsp; 👋 I'm Copter, your MUIC Assistant.</span><p>I can help you with course registration, campus directions, academic policies, and much more! Try asking me things like:</p><ul style="list-style: none;"><li>" Where is Building 1? "</li><li>" How do I register for courses? "</li><li>" What's my program structure? "</li></ul><p>Let's start by typing <strong>" who am I "</strong> to see your profile! 😊</p>`,
                time: this.moment().format('LT'),
                feedback: false,
            }];
        },

        setMassagesData(arrayMsg, texCase) {
            if (arrayMsg.length === 0) {
                if (texCase === 'listToppic') {
                    return this.getDefaultIntroMessage();
                }
                return `Copter is thinking... 🤔`;
            }

            if (texCase === 'listToppic') {
                return arrayMsg.map(element => ({
                    id: element.id,
                    from: element.type === "ASSISTANT" ? 'them' : 'me',
                    text: `${element.content}`,
                    time: `${this.moment(element.created_at).format('HH:ss:mm')}`,
                    feedback: !element.has_feedback,
                }));
            }

            return `${arrayMsg[0].content}`;
        },
        createDefaultChat() {
            return {
                id: 9999,
                name: `Hi there! I'm Copter`,
                avatar: "",
                lastMessage: "",
                messages: [
                    {
                        id: '8888',
                        from: "them",
                        text: `<span class='text-dark' >Hi <strong>${this.userProfile.name}</strong>! &nbsp;&nbsp;&nbsp; 👋 I'm Copter, your MUIC Assistant.</span><p>I can help you with course registration, campus directions, academic policies, and much more! Try asking me things like:</p><ul style="list-style: none;"><li>" Where is Building 1? "</li><li>" How do I register for courses? "</li><li>" What's my program structure? "</li></ul><p>Let's start by typing <strong>" who am I "</strong> to see your profile! 😊</p> <span class='text-danger' >Please click icon " <b><svg viewBox="64 64 896 896" data-icon="form" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z"></path><path d="M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z"></path></svg></b> " create new toppic`,
                        time: this.moment().format('LT'),
                        feedback: false,
                    },
                ],
                updated_at: this.moment().format(),
                created_at: this.moment().format(),
                is_active: true,
            };
        },
        mapChatResults(results) {
            return results.map((item) => {
                return {
                    id: item.id,
                    name: this.setMassagesData(item.messages, `Title`),
                    avatar: "",
                    lastMessage: "",
                    messages: this.setMassagesData(item.messages, `listToppic`),
                    updated_at: item.updated_at,
                    created_at: item.created_at,
                    is_active: item.is_active,
                };
            });
        },
        async fetchChatApps() {
            try {
                const res = await this.$http.get('/line-bot/ai/app/');
                if ([200, 201].includes(res.status)) {
                    if (res.data.results.length === 0) {
                        this.chats.push(this.createDefaultChat());
                        const indexLoading = this.chats.findIndex(itemLoad => itemLoad.id === 999);
                        if (indexLoading !== -1) {
                            this.chats.splice(indexLoading, 1);
                        }
                    } else {
                        this.chats = this.mapChatResults(res.data.results);
                    }
                    if (this.chats.length > 0) {
                        this.selectChat(this.chats[0]);
                    }
                } else {

                    const err = new Error('API Error');
                    err.res = res;
                    throw err;
                }
            } catch (error) {
                this.loadingToppic = false;
                this.loadingChat = false;
                this.loadingContent = false;
                this.closeInput = true;
            }
        },
        async getHistory() {
            this.loadAllcontent = false;
            this.visibleModal = false;
            try {
                const resrole = await this.$http.get(`/whoami-apps/`);
                if (resrole.status === 200) {

                    this.closeInput = false;
                    this.loadingContent = true;
                    this.loadingToppic = true;
                    this.loadingChat = true;
                    this.dataToppic = [];
                    this.dataChat = [];
                    this.dataViewMsg = [];
                    this.chats = [{
                        id: 999,
                        name: "Loading ...",
                        avatar: "",
                        lastMessage: "",
                        messages: [],
                        updated_at: this.moment().format(),
                        created_at: this.moment().format(),
                        is_active: true,
                    }];

                    await this.fetchChatApps();
                    // ex
                    this.loadAllcontent = false;

                } else {

                    const err = new Error('API Error');
                    err.resrole = resrole;
                    throw err;
                }
            } catch (error) {

                this.loadAllcontent = true

            }

        },
        async onSearch(value) {
            this.idStatus = false
            this.errorStatus = ''
            const reg = /^-?\d*(\.\d*)?$/;
            if ((!Number.isNaN(value) && reg.test(value)) || value.length === 7) {
                try {
                    const res = await this.$http.get(`/student/profile/search_by_id/?q=${value}`);
                    if ([200, 201].includes(res.status)) {
                        this.userName = value
                        this.idStatus = res.data.found
                        this.errorStatus = res.data.found ? `` : `Student id: ${value} not found !!!`
                    }
                    else {
                        const error = new Error('API Error');
                        error.res = res;
                        throw error;
                    }
                } catch (error) {
                    this.idStatus = false
                    this.errorStatus = `Student id: ${value} not format !!!`
                    this.userName = ''
                }
            } else {
                this.userName = ''
                this.errorStatus = `Student id: ${value} not format !!!`
            }
        },
        onChangeFormValidate(e) {
            const { value } = e.target;
            const reg = /^-?\d*(\.\d*)?$/;
            if ((!Number.isNaN(value) && reg.test(value)) || value === '' || value === '-') {
                this.userName = Number.parseInt(`${value}`) <= 6781308 ? `${value}` : '';
            } else {
                this.userName = 6280123
            }
        },
        handleOpenmodalProricy() {
            this.modalProricy = true
        },
        handleClosemodalProricy() {
            this.modalProricy = false
        },
        handleOpenModalId() {
            this.idStatus = false
            this.errorStatus = ``
            this.userName = ''
            this.createToppic()
        },
        handleCloseModalId() {
            this.modalUserId = false
        },
        async createToppic() {

            this.firstChat = 'first'
            this.loadingCreateMsg = true

            this.chats.push({
                id: 999,
                name: "Loading ...",
                avatar: "",
                lastMessage: "",
                messages: [],
                updated_at: this.moment().format(),
                created_at: this.moment().format(),
                is_active: true,
            })

            try {
                const res = await this.$http.post('/line-bot/ai/app/')
                if ([201].includes(res.status)) {
                    await this.getHistory()
                    this.viewHistoryChat = true
                    this.loadingCreateMsg = false
                    this.handleCloseModalId()
                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                this.loadingCreateMsg = false
                this.$notification.open({
                    style: {
                        backgroundColor: "#ff1919",
                        color: "#ffffff",
                    },
                    message: function (h) {
                        return h("div", [h("strong", { class: "" }, `Error`)]);
                    },
                    description: `Promblem issue Copter is experiencing an issue and is currently being fixed. Please try again later.`,
                });
            }

        },

        handleKeyDown(event) {
            // ถ้ากด Enter โดยไม่ได้กด Shift
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault()
                this.handleSendMessage(false)
            }
            // ถ้ากด Shift + Enter จะขึ้นบรรทัดใหม่ตามปกติ
        },

        adjustTextareaHeight() {
            const textarea = this.$refs.messageInput;
            textarea.style.height = "auto"; // รีเซ็ตก่อนขยาย
            textarea.style.height = `${textarea.scrollHeight}px`; // ปรับตามเนื้อหา
        },



        async handleSendMessage(checkReply) {
            this.visiblePopcon = false
            this.loadingFeed = false
            if (![false, 'false'].includes(checkReply)) {
                await this.sendMessageWithRetry(this.newMessage, false, null, checkReply);
            } else {
                if (this.newMessage.trim() !== "") {
                    await this.sendMessageWithRetry(this.newMessage, false, null, checkReply);
                }
            }
        },

        handleUserMsgUpdate(messageText, checkReply, chatIndex, userMessageId) {
            if (checkReply && ![false, 'false'].includes(checkReply)) {
                const delIndex = this.activeChat.messages.findIndex(msg => msg.id === `${checkReply}`);
                if (delIndex !== -1) {
                    this.activeChat.messages.splice(delIndex + 1);
                    this.chats[chatIndex].messages.splice(delIndex + 1);
                }
                return;
            }

            this.$nextTick(() => this.adjustTextareaHeight());
            this.viewHistoryChat = false;
            this.chats[chatIndex].messages.push({
                id: userMessageId,
                from: "me",
                text: messageText,
                time: this.moment().format('LT'),
                feedback: false
            });
            this.newMessage = "";
        },

        handleAssistantMsgUpdate(isRetry, timeoutMessageId, chatIndex, assistantMessageId) {
            if (isRetry && timeoutMessageId) return;

            if (chatIndex !== -1) {
                this.chats[chatIndex].messages.push({
                    id: assistantMessageId,
                    from: "them",
                    text: ``,
                    time: this.moment().format('LT'),
                    feedback: true
                });
            }
        },

        async performStreamRequest(config, timeoutPromise, callbacks) {
            const { isRetry, timeoutMessageId, index, chatIndex, assistantMessageId, userMessageId, originalMessage } = callbacks;

            const requestPromise = this.$http({
                ...config,
                responseType: 'stream',
                onDownloadProgress: (progressEvent) => {
                    const rawText = progressEvent.currentTarget.response;
                    if (config.url.includes('stream_message')) this.resText = '';

                    if (isRetry && timeoutMessageId) {
                        this.processStreamResponseForTimeout(index, rawText, chatIndex, timeoutMessageId);
                    } else {
                        this.processStreamResponse(index, rawText, chatIndex, assistantMessageId, userMessageId, originalMessage);
                    }
                }
            });
            return Promise.race([requestPromise, timeoutPromise]);
        },

        handleTimeoutError(chatIndex, isRetry, timeoutMessageId, assistantMessageId, messageText) {
            this.resText = '';
            let timeoutNotificationId;

            if (chatIndex !== -1 && !isRetry) {
                const assistantIndex = this.chats[chatIndex].messages.findIndex(msg => msg.id === assistantMessageId);
                if (assistantIndex !== -1) this.chats[chatIndex].messages.splice(assistantIndex, 1);

                timeoutNotificationId = 'timeout-notification-' + Date.now();
                this.chats[chatIndex].messages.push({
                    id: timeoutNotificationId,
                    from: "them",
                    text: `<strong>🤔 Copter is thinking Message sending is taking too long (more than 5 minutes). The system will automatically resend the message. Please wait a moment <span class="dots"><span>.</span><span>.</span><span>.</span></span></strong>`,
                    time: this.moment().format('LT'),
                    feedback: false
                });
            } else if (chatIndex !== -1 && isRetry && timeoutMessageId) {
                timeoutNotificationId = timeoutMessageId;
            }

            this.viewHistoryChat = true;
            if (this.firstChat) {
                if (chatIndex !== -1) this.chats[chatIndex] = { ...this.chats[chatIndex], name: messageText };
                this.firstChat = '';
            }

            setTimeout(() => {
                this.sendMessageWithRetry(messageText, true, timeoutNotificationId);
            }, 1000);
        },

        handleGeneralError(error, chatIndex, isRetry, timeoutMessageId, assistantMessageId, messageText) {
            this.resText = '';
            console.error('Error in handleSendMessage:', error);

            if (chatIndex !== -1) {
                const errorMsg = `<span class='text-danger'>[Code ${error.response?.status || 'Unknown'} !!] Copter Error: ${error.response?.statusText || error.message} <br/> Please refresh page and create new topic</span>`;

                if (isRetry && timeoutMessageId) {
                    const timeoutIndex = this.chats[chatIndex].messages.findIndex(msg => msg.id === timeoutMessageId);
                    if (timeoutIndex !== -1) {
                        this.chats[chatIndex].messages[timeoutIndex] = {
                            ...this.chats[chatIndex].messages[timeoutIndex],
                            text: errorMsg,
                        };
                    }
                } else {
                    const assistantIndex = this.chats[chatIndex].messages.findIndex(msg => msg.id === assistantMessageId);
                    if (assistantIndex !== -1) this.chats[chatIndex].messages.splice(assistantIndex, 1);

                    this.chats[chatIndex].messages.push({
                        id: error.response?.status || 'error',
                        from: "them",
                        text: errorMsg,
                        time: this.moment().format('LT'),
                        feedback: false
                    });
                }
            }
            this.viewHistoryChat = true;
            if (this.firstChat) {
                if (chatIndex !== -1) this.chats[chatIndex] = { ...this.chats[chatIndex], name: messageText };
                this.firstChat = '';
            }
        },

        async sendMessageWithRetry(messageText, isRetry = false, timeoutMessageId = null, checkReply) {
            const chatIndex = this.chats.findIndex(chat => chat.id === this.activeChat.id);
            const userMessageId = crypto.randomUUID();

            this.handleUserMsgUpdate(messageText, checkReply, chatIndex, userMessageId);

            const assistantMessageId = (isRetry && timeoutMessageId) ? timeoutMessageId : crypto.randomUUID();
            this.handleAssistantMsgUpdate(isRetry, timeoutMessageId, chatIndex, assistantMessageId);

            this.loadingStream = assistantMessageId;
            this.resText = assistantMessageId;

            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => reject(new Error('Request timeout after 5 minutes')), 5 * 60 * 1000);
            });

            try {
                const config = {};
                if (checkReply && ![false, 'false'].includes(checkReply)) {
                    config.method = 'post';
                    config.url = `/line-bot/ai/app/${this.activeChat.id}/retry_message_stream/`;
                    config.data = { message_id: `${checkReply}` };
                } else {
                    config.method = 'post';
                    config.url = `/line-bot/ai/app/${this.activeChat.id}/stream_message/`;
                    config.data = { message: `${messageText}` };
                }

                await this.performStreamRequest(config, timeoutPromise, {
                    isRetry, timeoutMessageId, index: 0, chatIndex, assistantMessageId, userMessageId, originalMessage: messageText
                });

                if (this.firstChat) {
                    if (chatIndex !== -1) this.chats[chatIndex] = { ...this.chats[chatIndex], name: messageText };
                    this.firstChat = '';
                    this.resText = '';
                }
                this.viewHistoryChat = true;

            } catch (error) {
                if (error.message && error.message.includes('timeout after 5 minutes')) {
                    this.handleTimeoutError(chatIndex, isRetry, timeoutMessageId, assistantMessageId, messageText);
                } else {
                    this.handleGeneralError(error, chatIndex, isRetry, timeoutMessageId, assistantMessageId, messageText);
                }
            }
        },

        handleStreamErrorPacket(chatIndex, messageIndex, accumulatedText, originalMessage) {
            const newContentError = `Copter is unable to find an answer for you. Please press the reply button to ask your question again.`;
            const finalText = accumulatedText + newContentError;

            this.chats[chatIndex].messages[messageIndex].text = finalText;
            this.$nextTick(() => this.scrollToBottom());

            setTimeout(() => {
                this.chats[chatIndex].messages.splice(messageIndex, 1);
                this.newMessage = originalMessage;
                this.handleSendMessage(false);
            }, 1000);
            return finalText;
        },

        processSingleDataPacket(data, chatIndex, messageIndex, userInMs, gError, gSuccess, accumulatedText, originalMessage) {
            if (data.type === 'chunk') {
                if (data.content === '\n') gError.push(data.content);
                else gSuccess.push(data.content);
            }

            if (['start', 'progress', 'analyzing', 'generating', 'chunk'].includes(data.type) && chatIndex !== -1 && data.content !== '```json { "student_info": { "student_id":') {
                const newContent = data.content;
                if (['start', 'progress', 'analyzing', 'generating'].includes(data.type)) {
                    this.chats[chatIndex].messages[messageIndex].text = `<strong> 🤔 Copter is ${newContent.replace('...', '')} <span class="dots"><span>.</span><span>.</span><span>.</span></span></strong>`;
                    return accumulatedText;
                }

                const updatedText = accumulatedText + newContent;
                this.chats[chatIndex].messages[messageIndex].text = gError.length === 1 && gSuccess.length === 0 ? 'Please refresh answer !!' : updatedText;
                this.$nextTick(() => this.scrollToBottom());
                return updatedText;

            } else if (data.type === 'error' && chatIndex !== -1) {
                return this.handleStreamErrorPacket(chatIndex, messageIndex, accumulatedText, originalMessage);
            } else if (data.type === 'done') {
                this.chats[chatIndex].messages[messageIndex].id = data.message_id;
                this.activeChat.messages[userInMs].id = data.latest_user_message_id;
                this.viewHistoryChat = true;
                this.loadingStream = '';
            }
            return accumulatedText;
        },

        processStreamResponse(index, rawText, chatIndex, messageId, userMessageId, originalMessage) {
            if (!rawText) return;

            const lines = rawText.split('data: ');
            const messageIndex = this.chats[chatIndex].messages.findIndex(msg => msg.id === messageId);
            const userInMs = this.chats[chatIndex].messages.findIndex(msg => msg.id === `${userMessageId}`);

            if (messageIndex !== -1) this.resText = '';

            let accumulatedText = '';
            let gError = [];
            let gSuccess = [];

            lines.forEach((line) => {
                if (!line.trim()) return;
                try {
                    const data = JSON.parse(line);
                    accumulatedText = this.processSingleDataPacket(data, chatIndex, messageIndex, userInMs, gError, gSuccess, accumulatedText, originalMessage);
                } catch (e) {
                    console.warn('Error parsing SSE data:', e);
                }
            });
        },

        processStreamResponseForTimeout(index, rawText, chatIndex, timeoutMessageId) {
            if (chatIndex !== -1) {
                const timeoutIndex = this.chats[chatIndex].messages.findIndex(
                    msg => msg.id === timeoutMessageId
                );
                if (timeoutIndex !== -1) {
                    // อัพเดทข้อความใน timeout notification
                    this.chats[chatIndex].messages[timeoutIndex].text = rawText;
                    this.chats[chatIndex].messages[timeoutIndex].feedback = true; // เพิ่ม feedback option
                }
            }
            // อัพเดท lastMessage สำหรับแสดงใน chat list
            if (chatIndex !== -1) {
                this.chats[chatIndex].lastMessage = rawText;
            }
        },


        ////////////////////////////////////////////////////////////////////////////////////////

        async getHistoryAgain(idActive) {
            this.resText = ''
            let a = []
            try {
                const res = await this.$http.get('/line-bot/ai/app/');
                if ([200, 201].includes(res.status)) {

                    a = res.data.results.filter((data) => data['id'] === idActive).map((item, index) => {
                        return {
                            id: item.id,
                            name: this.setMassagesData(item.messages, `Title`),
                            avatar: "",
                            lastMessage: "",
                            messages: this.setMassagesData(item.messages, `listToppic`),
                            updated_at: item.updated_at,
                            created_at: item.created_at,
                            is_active: item.is_active,
                        };
                    });
                    this.selectChat(a[0]);

                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) { }
        },

        // FeedBack

        clearValueFeedBack(id) {
            this.loadingFeed = false
            this.visiblePopcon = id
            this.valueRate = 0
            this.valueComment = ''
        },
        closeFeedBack() {
            this.loadingFeed = false
            this.visiblePopcon = false
            this.valueRate = 0
            this.valueComment = ''
        },
        async feedbackMsg(token, idToppic) {
            this.loadingFeed = true
            let arrPatch = []
            let message = {
                message_id: `${token}`,
                comment: `${this.valueComment}`,
                rating: Number.parseInt(this.valueRate)
            }

            const formData = new FormData();
            formData.append('message_id', `${token}`);
            formData.append('comment', `${this.valueComment}`);
            formData.append('rating', Number.parseInt(this.valueRate));
            try {
                const res = await this.$http.post(`/line-bot/ai/app/${idToppic}/feedback/`,
                    // formData,
                    JSON.stringify(message),
                    {
                        headers: { "Content-Type": "multipart/form-data, application/json" },
                    }
                )
                if ([200, 201].includes(res.status)) {
                    // อัพเดท ค่า feedback ของข้อความนั้น
                    const index = this.activeChat.messages.findIndex(itemRe => itemRe.id === res.data.message)
                    this.activeChat.messages[index] = {
                        ...this.activeChat.messages[index],
                        feedback: false
                    }
                    arrPatch.push(this.activeChat.messages[index]);
                    this.activeChat.messages.splice(index, 1, arrPatch[0]);
                    this.closeFeedBack()
                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                this.$notification.open({
                    style: {
                        backgroundColor: "#ff1919",
                        color: "#ffffff",
                    },
                    message: function (h) {
                        return h("div", [h("strong", { class: "" }, `Error`)]);
                    },
                    description: `Promblem issue Copter is experiencing an issue and is currently being fixed. Please try again later.`,
                });
            }
        },
        async feedbackMsgBad(token, idToppic) {
            this.loadingFeed = true
            let arrPatch = []
            let message = {
                message_id: `${token}`,
                comment: `Bad Response`,
                rating: 0
            }
            const formData = new FormData();
            formData.append('message_id', `${token}`);
            formData.append('comment', `Bad Response`);
            formData.append('rating', 0);
            try {
                const res = await this.$http.post(`/line-bot/ai/app/${idToppic}/feedback/`,
                    // formData,    
                    JSON.stringify(message),
                    {
                        headers: { "Content-Type": "multipart/form-data, application/json" },
                    }
                )
                if ([200, 201].includes(res.status)) {
                    // อัพเดท ค่า feedback ของข้อความนั้น
                    const index = this.activeChat.messages.findIndex(itemRe => itemRe.id === res.data.message)
                    this.activeChat.messages[index] = {
                        ...this.activeChat.messages[index],
                        feedback: false
                    }
                    arrPatch.push(this.activeChat.messages[index]);
                    this.activeChat.messages.splice(index, 1, arrPatch[0]);
                    this.closeFeedBack()
                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                this.$notification.open({
                    style: {
                        backgroundColor: "#ff1919",
                        color: "#ffffff",
                    },
                    message: function (h) {
                        return h("div", [h("strong", { class: "" }, `Error`)]);
                    },
                    description: `Promblem issue Copter is experiencing an issue and is currently being fixed. Please try again later.`,
                });
            }
        }

    },
};
</script>

<style scoped>
.typing-indicator {
    left: 0;
    align-items: center;
    color: rgba(0, 0, 0, 0.45);
    font-size: 16px;
}

.typing-text {
    margin-left: 4px;
}

/* Animation for dots */
.dots span {
    animation: dotFade 1.4s infinite;
    opacity: 0;
    margin-left: 2px;
}

.dots span:nth-child(2) {
    animation-delay: 0.2s;
}

.dots span:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes dotFade {
    0% {
        opacity: 0;
    }

    20% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

/* รีเซ็ต */
/* * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Sarabun', sans-serif;
    background: #ffffff;
  } */

/* Layout หลัก */
.chat-container {
    display: flex;
    height: 80dvh !important;
    width: 100%;
    /* border-radius: 15%; */
    /* background: transparent !important; */
}

/* Card Profile */
.profile-main {
    display: flex;
    flex-direction: column;
}

.profile-card {
    display: flex;
    align-items: center;
    background: white;
    padding: 9px;
    border-bottom: 1px solid #ddd;
    border-radius: 0;
}

.profile-avatar {
    width: 60px;
    height: 60px;
    border-radius: 20px 20px 0 0;
    /* border-radius: 50%; */
    margin-right: 15px;
}

.profile-info h3 {
    margin: 0;
    font-size: 18px;
    width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.status {
    font-size: 14px;
    color: gray;
}

.online {
    color: green;
}

.offline {
    color: red;
}

/* Sidebar (รายการแชท) */
.sidebar {
    width: 300px;
    background: transparent !important;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    border-radius: 20px 0 0 0;
    /* box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1); */
}

.sidebar-header {
    height: 88px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    /* background: #f0f0f0; */
    border-bottom: 1px solid #ccc;
    /* border-radius: 0; */
    font-family: 'Sarabun', sans-serif !important;
    font-weight: 900;
}

.sidebar-hidden {
    display: none;
}

/* รายการแชท */
.chat-name {
    font-family: 'Sarabun', sans-serif !important;
    font-weight: 900;
    font-size: 16px;
    width: 220px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.chat-list {
    list-style: none;
    overflow-y: auto;
    flex: 1;
    padding: 10px;
}

.chat-list li {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    /* เพิ่มระยะห่างภายในให้มากขึ้น */
    margin: 8px 0;
    /* เพิ่มระยะห่างระหว่างรายการ */
    border-radius: 12px;
    cursor: pointer;
    transition: background 0.3s, transform 0.3s ease, margin 0.3s;
}

/* เมื่อ Hover บน chat-list */
.chat-list li:hover {
    background: #e0e0e0;
    /* สีพื้นหลังเมื่อ Hover */
    transform: scale(1.03);
    /* ขยายเล็กน้อย */
    margin-left: 10px;
    /* ย้ายรายการไปทางซ้ายเล็กน้อย */
    margin-right: 10px;
    /* ย้ายรายการไปทางขวาเล็กน้อย */
}

/* เมื่อรายการ Chat เป็น Active */
.active-chat {
    background: #E6E6FA;
    /* สีม่วงอ่อนสำหรับ active */
    color: #4A235A;
    font-weight: bold;
    transform: scale(0.95);
    margin-left: 20px;
    /* ย้ายรายการไปทางซ้ายเล็กน้อย */
    margin-right: 20px;
    /* ย้ายรายการไปทางขวาเล็กน้อย */
}

/* กล่องแชท */
.chat-messages {
    height: calc(100dvh - 120px);
    overflow-y: auto;
    transition: height 0.3s ease;
}



.chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 0px;
    box-shadow: -3px 0 10px rgba(0, 0, 0, 0.1);
}

/* Header แชท */
.chat-header {
    display: flex;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #6a0dad, #de5a5a);
    color: white;
    border-bottom: 1px solid #ccc;
    border-radius: 0 15px 0 0;
}

.chat-header h6 {
    font-family: 'Sarabun', sans-serif !important;
    font-weight: 500;
    margin-left: 10px;
}

/* กล่องข้อความ */
.chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 15px;
    background: #e9e9e9;
    display: flex;
    flex-direction: column;
    border-radius: 0;
    border: 0px solid #ffffff;
}

/* ข้อความ */
.message {
    max-width: 90%;
    padding: 12px;
    border-radius: 18px;
    margin: 5px 0;
    position: relative;
    font-size: 20px;
    word-wrap: break-word;
}

.sent {
    align-self: flex-end;
    /* background: #dcf8c6; */
    text-align: left;
    padding: 12px;
}

.flex-recive {
    display: flex;
    gap: 10px;
    justify-content: flex-start;
}

.bg-send {
    background: #e4e4ff;
    border: 0px solid #fdfdfd;
    padding: 10px;
    border-radius: 18px 18px 18px 18px;
}

.bg-recive {

    background: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    border-radius: 18px 18px 18px 18px;
    max-width: 950px;

}

.received {
    align-self: flex-start;
    border-radius: 18px 18px 18px 0px;
    /* background: #fff; */
    /* border: 1px solid #ddd; */
}

/* ข้อความ */
.message-text {
    margin: 0;
}

/* เวลา (timestamp) */
.message-time {
    font-size: 10px;
    color: gray;
    display: block;
    margin-top: 0px;
}

/* ช่องพิมพ์ข้อความ */

.chat-input {
    display: flex;
    align-items: center;
    padding: 10px;
    background: #fff;
    border-top: 1px solid #ddd;
    border-radius: 0 0 20px 20px;
}

.chat-input textarea {
    flex-grow: 1;
    min-height: 40px;
    /* กำหนดความสูงขั้นต่ำ */
    max-height: 120px;
    /* ป้องกันสูงเกินไป */
    padding: 10px;
    border: none;
    border-radius: 10px;
    outline: none;
    resize: none;
    /* ปิดการปรับขนาดเอง */
    overflow-y: hidden;
    background: #f4f4f4;
}

.send-button {
    margin-left: 10px;
    height: 100%;
    background: #462279;
    color: white;
    border: none;
    border-radius: 10%;
    padding: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    transition: background 0.3s;
}

.send-button:hover {
    background: #C0A0C0;
}

.ai-warning {
    text-align: center;
    font-size: 12px;
    color: #6e6e6e;
    margin-top: 5px;
    font-family: 'Sarabun', sans-serif !important;
    font-weight: 300;
}

/* .chat-input {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 10px;
    border-top: 1px solid #ddd;
}

.chat-input input {
    flex-grow: 1;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;
    outline: none;
} */

/* ปุ่ม Send (แบบ Round UI + สีม่วงอ่อน) */
/* .chat-input button {
    background-color: #4A235A;
    margin-left: 10px;
    padding: 10px 15px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.3s ease;
    color: #ffffff;
    font-weight: 700;
} */

/* ทำให้ขยายเล็กน้อย */
.chat-vote-icon {
    border-radius: 20%;
    /* ทำให้เป็นวงกลม */
    transition: all 0.3s ease-in-out;
}

.chat-vote-icon:hover {
    background-color: rgba(24, 144, 255, 0.15);
    /* พื้นหลังสีฟ้าอ่อน */
    box-shadow: 0 4px 10px rgba(24, 144, 255, 0.3);
    /* เงานุ่มๆ */
    transform: scale(1.1);
    /* ขยายเล็กน้อย */
    font-weight: 900;
}

.btn-create button {
    background-color: #4A235A;
    margin-left: 10px;
    padding: 10px 15px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.3s ease;
    color: #ffffff;
    font-weight: 700;
}

/* Responsive */
@media (max-width: 1200px) {

    .avtar-v {
        display: none;
    }

    .chat-container {
        height: 100dvh;
        border-radius: 0%;
    }

    .sidebar {
        width: 100%;
        height: 100vh;
        border-radius: 0;
        border: 0px solid #ccc;
        overflow-y: auto;
    }

    .chat-list {
        max-height: 70dvh;
        overflow-y: auto;
    }

    .chat-messages {
        height: calc(100dvh - 120px);
        overflow-y: auto;
        transition: height 0.3s ease;
        font-size: 10px !important;
    }

    .chat-box {
        width: 100%;
        height: 77dvh;
    }

    .chat-header {
        display: flex;
        align-items: center;
        padding: 15px;
        background: #462279;
        color: white;
        border-bottom: 1px solid #ccc;
        border-radius: 0;
    }

    .chat-name {
        font-family: 'Sarabun', sans-serif !important;
        font-weight: 900;
        font-size: 18px;
        width: 300px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

}

/* Scrollbar ทั่วไป */
::-webkit-scrollbar {
    width: 6px;
    /* ทำให้แคบลง */
}

/* สีพื้นหลังของ Scrollbar */
::-webkit-scrollbar-track {
    background: #f0f0f0;
    /* สีเทาอ่อน */
    border-radius: 10px;
}

/* แถบ Scrollbar */
::-webkit-scrollbar-thumb {
    background: #d6d6d6;
    /* สีม่วงอ่อน */
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
}

/* เมื่อ Hover บน Scrollbar */
::-webkit-scrollbar-thumb:hover {
    background: #d6d6d6;
    /* สีม่วงเข้มขึ้นเล็กน้อย */
}

@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@300&display=swap');

.markdown {
    font-family: 'Kanit', sans-serif;
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    line-height: 1.5;
    color: #24292e;
    max-width: 800px;
    /* จำกัดความกว้างสูงสุด */
    word-wrap: break-word;
    /* ตัดคำเมื่อยาวเกิน */
    overflow-wrap: break-word;
    /* รองรับ browser เก่า */
}

/* จัดการข้อความยาว */
.markdown p,
.markdown li,
.markdown blockquote,
.markdown td {
    white-space: pre-line;
    /* รักษาการขึ้นบรรทัดใหม่จาก markdown */
    word-break: break-word;
    /* ตัดคำเมื่อยาวเกิน */
    max-width: 100%;
    /* ไม่ให้ล้นพื้นที่ */
}

/* จัดการ code ที่ยาว */
.markdown pre {
    white-space: pre-wrap;
    /* รักษา formatting แต่ขึ้นบรรทัดใหม่เมื่อยาวเกิน */
    word-wrap: break-word;
    max-width: 100%;
}

.markdown code {
    white-space: pre-wrap;
    word-wrap: break-word;
}

/* จัดการ table ที่ยาว */
.markdown table {
    table-layout: fixed;
    /* ให้ความกว้างคอลัมน์คงที่ */
    width: 100%;
}

.markdown th,
.markdown td {
    overflow-wrap: break-word;
    min-width: 100px;
    /* ความกว้างขั้นต่ำของคอลัมน์ */
}

/* จัดการ link ที่ยาว */
.markdown a {
    word-wrap: break-word;
    overflow-wrap: break-word;
}


/* Typography */
.markdown h1,
.markdown h2,
.markdown h3,
.markdown h4,
.markdown h5,
.markdown h6 {
    margin: 0;
    line-height: 1.5;
    font-family: 'Kanit', sans-serif;
    font-weight: 600;
}

.markdown h1 {
    font-size: 2em;
}

.markdown h2 {
    font-size: 1.5em;
}

.markdown h3 {
    font-size: 1.25em;
}

.markdown h4 {
    font-size: 1em;
}

.markdown h5 {
    font-size: 0.875em;
}

.markdown h6 {
    font-size: 0.85em;
}

.markdown p {
    margin: 0;
    line-height: 1.5;
}

/* Lists */
.markdown ul,
.markdown ol {
    margin: 0;
    padding-left: 2em;
    line-height: 1.5;
}

.markdown li {
    line-height: 1.5;
}

.markdown li+li {
    margin-top: 0.25em;
}

/* Code */
.markdown code {
    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
    font-size: 85%;
    background-color: rgba(27, 31, 35, 0.05);
    padding: 0.2em 0.4em;
    border-radius: 3px;
}

.markdown pre {
    margin: 0;
    line-height: 1.5;
    padding: 1em;
    background-color: #f6f8fa;
    border-radius: 3px;
    overflow: auto;
}

.markdown pre code {
    background: none;
    padding: 0;
}

/* Links */
.markdown a {
    color: #0366d6;
    text-decoration: none;
}

.markdown a:hover {
    text-decoration: underline;
}

/* Blockquotes */
.markdown blockquote {
    margin: 0;
    padding-left: 1em;
    color: #6a737d;
    border-left: 0.25em solid #dfe2e5;
}

/* Tables */
.markdown table {
    border-spacing: 0;
    border-collapse: collapse;
    width: 100%;
}

.markdown table th,
.markdown table td {
    padding: 6px 13px;
    border: 1px solid #dfe2e5;
}

.markdown table tr {
    background-color: #fff;
}

.markdown table tr:nth-child(2n) {
    background-color: #f6f8fa;
}

/* Horizontal Rule */
.markdown hr {
    height: 0.25em;
    padding: 0;
    margin: 24px 0;
    background-color: #e1e4e8;
    border: 0;
}

/* Images */
.markdown img {
    max-width: 100%;
    height: auto;
}
</style>